// Közös választéklisták a CAESAR ügykezelőhöz.
export const CAESAR_OPCIOK = {
  szemelyTipus: [
    { value: 'termeszetes', label: 'Természetes személy' },
    { value: 'jogi', label: 'Jogi személy / szervezet' },
    { value: 'hatosag', label: 'Hatóság' },
  ],
  // Szerepkör az ügyben – szabad szöveg, de gyakori értékek gyorsválasztóként.
  szerep: [
    { value: 'Ügyfél', label: 'Ügyfél' },
    { value: 'EllenérdekűFél', label: 'Ellenérdekű fél' },
    { value: 'Tanú', label: 'Tanú' },
    { value: 'Képviselő', label: 'Képviselő' },
    { value: 'Hatóság', label: 'Hatóság' },
    { value: 'Egyéb', label: 'Egyéb' },
  ],
  allapot: [
    { value: 'nyitott', label: 'Nyitott' },
    { value: 'felfuggesztve', label: 'Felfüggesztve' },
    { value: 'lezarva', label: 'Lezárva' },
  ],
  szamformatum: [
    { value: 'sorszam/ev', label: 'Sorszám/Év (1/2026)' },
    { value: 'ev/sorszam', label: 'Év/Sorszám (2026/1)' },
  ],
  cimTipus: [
    { value: 'lakcim', label: 'Lakcím' },
    { value: 'tartozkodasi', label: 'Tartózkodási hely' },
    { value: 'szekhely', label: 'Székhely' },
    { value: 'telephely', label: 'Telephely' },
    { value: 'fioktelep', label: 'Fióktelep' },
    { value: 'levelezesi', label: 'Levelezési cím' },
    { value: 'egyeb', label: 'Egyéb' },
  ],
  okmanyTipus: [
    { value: 'szig', label: 'Személyi igazolvány' },
    { value: 'utlevel', label: 'Útlevél' },
    { value: 'vezetoi', label: 'Vezetői engedély' },
    { value: 'lakcimkartya', label: 'Lakcímkártya' },
    { value: 'egyeb', label: 'Egyéb' },
  ],
  iratIrany: [
    { value: 'kimeno', label: 'Kimenő' },
    { value: 'beerkezo', label: 'Beérkező' },
    { value: 'egyeb', label: 'Egyéb' },
  ],
  iratTipus: [
    { value: 'megbizasi_szerzodes', label: 'Megbízási szerződés' },
    { value: 'meghatalmazas', label: 'Meghatalmazás' },
    { value: 'beadvany', label: 'Beadvány' },
    { value: 'hatarozat', label: 'Határozat' },
    { value: 'level', label: 'Levél' },
    { value: 'jegyzokonyv', label: 'Jegyzőkönyv' },
    { value: 'egyeb', label: 'Egyéb' },
  ],
};
